import React, { useState } from 'react';
import { toast } from 'react-toastify';
import Button from '../../ui/button';
import { alertBulkArchive } from '../../../redux/api/alertAPI';
import { useTranslation } from 'react-i18next';

const ArchiveAlertModal = ({ isOpen, onClose, data, archived = true }) => {
    const {t} = useTranslation("common")
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const closeModal = (refresh = false) => {
        if (loading) return;
        setError(null);
        onClose(refresh);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);

        try {
            const ids = Array.isArray(data) ? data : [data];

            if (ids.length === 0) {
                setLoading(false);
                closeModal();
                return;
            }

            const { error, data: result } = await alertBulkArchive(ids, archived, { skipSuccessToast: true });

            if (error) {
                setError(error);
            } else {
                const count = result?.updated ?? ids.length;
                if (count > 0) {
                    toast.success(
                        archived
                            ? `${count} alert(s) archived.`
                            : `${count} alert(s) restored.`
                    );
                }
                closeModal(true);
            }
        } catch (err) {
            console.error("Error archiving alert(s):", err);
            setError("An unexpected error occurred.");
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) {
        return null;
    }

    const isBulk = Array.isArray(data);
    const count = isBulk ? data.length : 1;

    return (
    <div data-testid="alert-archive-modal" className="grid space-y-4 w-auto m-2 bg-white p-8 rounded-3xl shadow-lg">
        <p className="text-center text-xl text-[#4C4C66] font-bold">
            {archived ? t('archive_confirmation') : t('unarchive_confirmation')}
        </p>
        <p className="text-center text-md text-[#4C4C66] font-normal">
            {archived
                ? (isBulk
                    ? `Are you sure you want to archive ${count} alerts?`
                    : "Are you sure you want to archive this alert?")
                : (isBulk
                    ? `Are you sure you want to restore ${count} alerts?`
                    : "Are you sure you want to restore this alert?")
            }
        </p>
        {error && (
            <p className="text-center text-red-500 bg-red-100 p-2 rounded-md">{error}</p>
        )}
        <div className='flex justify-center pt-4 space-x-5'>
            <Button onClick={() => closeModal()} size="large" color="cancel" disabled={loading}>
                {t('cancel')}
            </Button>
            <Button data-testid="alert-archive-submit" onClick={handleSubmit} type="submit" size="large" disabled={loading}>
                {loading
                    ? (archived ? t('archiving', 'Archiving...') : t('restoring', 'Restoring...'))
                    : (archived ? t('archive') : t('unarchive'))
                }
            </Button>
        </div>
    </div>
    );
};

export default ArchiveAlertModal;
